import { AimOutlined } from "@ant-design/icons";
import { isValidCoordinates } from "../utils/isValidCoordinates";
import { RefObject } from "react";
import { GpsBadge } from "./GpsBadge";

interface MapProps {
  mapRef: RefObject<HTMLDivElement>;
  geoReady: boolean;
  geoError: string | null;
  coords: [number, number] | null;
  accentColor: string;
  onRecenter: () => void;
}

export const Map = ({ mapRef, geoReady, coords, accentColor, onRecenter, geoError }: MapProps) => (
  <div className="relative w-full h-full bg-gradient-to-br from-blue-50 to-blue-100">
    <div ref={mapRef} className="absolute inset-0" />
    {geoReady && coords && isValidCoordinates(coords[0], coords[1]) && (
      <>
        <div
          className="absolute top-4 left-4 flex items-center gap-2 px-3 py-2 rounded-full z-[400] bg-white shadow-lg text-xs font-mono"
          style={{ background: "rgba(255,255,255,0.95)", backdropFilter: "blur(4px)" }}
        >
          <span className="inline-flex items-center gap-1">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
            <span className="font-bold">{coords[0].toFixed(5)}</span>
          </span>
          <span className="text-gray-300">•</span>
          <span className="font-bold">{coords[1].toFixed(5)}</span> -
          <GpsBadge geoReady={geoReady} geoError={geoError} />
        </div>
      </>
    )}
    <button
      type="button"
      onClick={onRecenter}
      disabled={!geoReady}
      className="absolute bottom-6 right-6 w-14 h-14 bg-white rounded-full shadow-2xl z-[1000] flex items-center justify-center transition-transform active:scale-90 hover:scale-105 border border-gray-200 disabled:opacity-50"
      title="Định tâm lại bản đồ"
    >
      <AimOutlined style={{ fontSize: 22, color: geoReady ? accentColor : "#999" }} />
    </button>
  </div>
);
